import { createAction } from "@reduxjs/toolkit";

const toggleFloatingMode = createAction("toggleFloatingMode");

export { toggleFloatingMode };
